import './instrument';
import { createRoot } from 'react-dom/client';
import 'tailwindcss/tailwind.css';
import 'index.css';
import { App } from 'App';
import * as Sentry from '@sentry/react';
import { config } from './utils/config';

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container, {
  onRecoverableError: !config.isDev ? Sentry.reactErrorHandler() : undefined,
});

root.render(
  !config.isDev ? (
    <Sentry.ErrorBoundary fallback={<p>Something went wrong!</p>}>
      <App />
    </Sentry.ErrorBoundary>
  ) : (
    <App />
  ),
);
